import request from '@/utils/request'

// 获取房源列表
export function getHouseList(params) {
  return request({
    url: '/api/houses/admin',
    method: 'get',
    params
  })
}

// 获取房源详情
export function getHouseDetail(id) {
  return request({
    url: `/api/houses/${id}`,
    method: 'get'
  })
}

// 更新房源基础信息
export function updateHouse(id, data) {
  return request({
    url: `/admin/api/houses/${id}`,
    method: 'put',
    data
  })
}

// 更新房源详情信息
export function updateHouseDetails(id, data) {
  return request({
    url: `/admin/api/houses/${id}/details`,
    method: 'put',
    data
  })
}

// 删除房源
export function deleteHouse(id) {
  return request({
    url: `/admin/api/houses/${id}`,
    method: 'delete'
  })
}

// 批量操作房源
export function batchOperateHouses(data) {
  return request({
    url: '/admin/api/houses/batch',
    method: 'post',
    data
  })
}

// 获取房源图片列表
export function getHouseImages(houseId) {
  return request({
    url: `/admin/api/houses/${houseId}/images`,
    method: 'get'
  })
}

// 更新图片信息
export function updateHouseImage(id, data) {
  return request({
    url: `/admin/api/houses/images/${id}`,
    method: 'put',
    data
  })
}

// 删除图片
export function deleteHouseImage(id) {
  return request({
    url: `/admin/api/houses/images/${id}`,
    method: 'delete'
  })
}

// 批量更新图片顺序
export function updateHouseImagesOrder(houseId, data) {
  return request({
    url: `/admin/api/houses/${houseId}/images/order`,
    method: 'put',
    data
  })
}